import { Helmet } from 'react-helmet';
import QuestionPage from '../../templates/question';
import Checkbox from '../../molecules/checkboxQuestion';
import { Q } from '../../../store/student/types';
import { titleAppend } from '../../../utilities/head';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../store';
import * as CoreActions from '../../../store/student/core/actions';
import { createNavigateForwardAction } from '../../../middleware/actions';

const LegalAdviseDisclaimer = () => {
  const complete = useSelector((state: ApplicationState) => state.student.core.legalAdviseDisclaimer);
  const legalAdviseDisclaimer = useSelector((state: ApplicationState) => state.student.core.legalAdviseDisclaimer);
  const config = useSelector((state: ApplicationState) => state.config);

  const dispatch = useDispatch();
  const onNext = () => {
    dispatch(createNavigateForwardAction());
  };

  const handleChange = (_key: string, isTicked: boolean) => {
    dispatch(CoreActions.updateLegalAdviseDisclaimer(isTicked));
  };

  const pageTitle = config.Checklist.Landing.title;

  return (
    <QuestionPage complete={complete} onNext={onNext} hideProgress={true}>
      <Helmet>
        <title>
          {pageTitle} {titleAppend}
        </title>
      </Helmet>

      <Checkbox
        key={Q.LEGAL_ADVICE_DISCLAIMER}
        id={Q.LEGAL_ADVICE_DISCLAIMER}
        label={pageTitle}
        blurb={config.Checklist.Landing.blurb}
        isTicked={legalAdviseDisclaimer}
        checkboxLabel={'I understand'}
        onChange={handleChange}
      />
    </QuestionPage>
  );
};

export default LegalAdviseDisclaimer;
